var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienMonster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 21v14h3v3h3v7h6v6h5 1v-6h16v6h6v-6h6v-7h3v-3h3v-15h-6v4 1h-7v-5h-4v-6h-6v6h-7v-6h-6v6h-4v5h-6v-5h-6z",
    fill: "#8967aa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 51h6v6h-6z",
    fill: "#8967aa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m50 51h6v6h-6z",
    fill: "#8967aa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.175 31h3.6v6h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 45h-6v-6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.583 25v-5h3.417",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.708 25v-5h-3.416",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 35h-3v-15h6v15",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 35v-15h6v15h-3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 20v-6h6v6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 20v-6h6v6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 35h3v3h-6v-3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 35v3h-6v-3h3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 51h6v6h-6z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 51h6v6h-6z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 45v6h-6v-6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 45h6v-6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 45v6h6v-6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.425 31h3.6v6h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 45h16",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 20h7",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 25h6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 25h7",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienMonster);
export default __webpack_public_path__ + "static/media/alien-monster.99ef2e07deebc30fc8cb863c7dfb4c47.svg";
export { ForwardRef as ReactComponent };